import React, { useEffect, useState, useCallback } from 'react';
import callrecorderApi from "src/api/callrecorderApi";
import { useAppSelector } from "src/store/hooks";

import { Card, Col, Row, Spin, Tag, Typography } from "antd";
import {
  MailOutlined,
  PercentageOutlined
} from "@ant-design/icons";

const { Text, Title } = Typography;

const ACCENT = '#6610f2';

interface SmsPackagePricing {
  id: number;
  name: string;
  sms_count: number;
  discount: string;
  price: string;
}

interface SmsPackagesCardsProps {
  uid: string;
}

const _SmsPackagesCards = ({ uid }: SmsPackagesCardsProps) => {
  const [packages, setPackages] = useState<SmsPackagePricing[]>([]);
  const [loading, setLoading] = useState(false);
  const packagesEntities = useAppSelector(state => state.callrecorder.smsPackages.entities);

  const fetchPricing = useCallback(() => {
    setLoading(true);
    callrecorderApi
      .get('/onesky/sms_packages/pricing', { params: { uid, active: true } })
      .then(response => setPackages(response.data.sms_packages || []))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, [uid]);

  useEffect(() => {
    fetchPricing();
  }, [fetchPricing, packagesEntities]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>;
  if (!packages.length) return <Text type="secondary">No packages available</Text>;

  return (
    <Row gutter={[16, 16]} justify="center">
      {packages.map((pkg, index) => (
        <Col key={pkg.id} flex="200px">
          <Card
            hoverable
            style={{
              textAlign: 'center',
              borderColor: index === 0 ? ACCENT : undefined,
              width: 200,
            }}
          >
            <Title level={5} style={{ marginBottom: 4 }}>{pkg.name}</Title>

            <div style={{ margin: '16px 0' }}>
              <Title level={2} style={{ margin: 0, color: ACCENT }}>
                ${pkg.price}
              </Title>
              <Text type="secondary">one-time</Text>
            </div>

            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <MailOutlined style={{ marginRight: 8, color: ACCENT }} />
                <Text>{pkg.sms_count} SMS</Text>
              </div>
              <div>
                <PercentageOutlined style={{ marginRight: 8, color: ACCENT }} />
                {parseFloat(pkg.discount) > 0
                  ? <Tag color="green">{pkg.discount}% off</Tag>
                  : <Text type="secondary">No discount</Text>
                }
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default _SmsPackagesCards;
